var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal-mask", on: { click: _vm.close } }),
      _vm._v(" "),
      _vm.isImageModal
        ? _c(
            "div",
            { staticClass: "modal-content-image" },
            [
              _c(
                "button",
                {
                  staticClass: "modal-button-image--exit",
                  attrs: { "aria-label": "Stäng modal" },
                  on: { click: _vm.close }
                },
                [_c("v-icon", { attrs: { name: "icon-close", size: "xs" } })],
                1
              ),
              _vm._v(" "),
              _vm._t("content")
            ],
            2
          )
        : _c("div", { staticClass: "modal-content modal-content--outer" }, [
            _c(
              "button",
              {
                staticClass: "modal-button--exit",
                attrs: { type: "button" },
                on: { click: _vm.close }
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.windowWidth > 600 ? "Stäng" : "") +
                    "\n\t\t\t\t\t"
                ),
                _c("v-icon", {
                  attrs: {
                    cssModifiers: "c-application-appartment--scale",
                    name: "icon-close",
                    size: "s"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-content modal-content--inner" },
              [_vm._t("content")],
              2
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }